import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, Check, Sparkles } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";

export function PaywallSheet({ open, onClose, reason }) {
  const navigate = useNavigate();
  const { t } = useLang();
  const perks = [t("paywall.perk1"), t("paywall.perk2"), t("paywall.perk3"), t("paywall.perk4")];
  return (
    <AnimatePresence>
      {open && (
        <>
          <motion.div className="fixed inset-0 z-50 bg-black/30" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} onClick={onClose} />
          <motion.div
            data-testid="paywall-sheet"
            className="fixed bottom-0 inset-x-0 z-50 mx-auto max-w-lg bg-decide-canvas rounded-t-3xl border-t border-decide-line px-6 pt-3 pb-8 shadow-[0_-4px_24px_rgba(0,0,0,0.08)]"
            initial={{ y: "100%" }} animate={{ y: 0 }} exit={{ y: "100%" }}
            transition={{ type: "spring", damping: 30, stiffness: 300 }}
            style={{ paddingBottom: "calc(env(safe-area-inset-bottom) + 2rem)" }}
          >
            <div className="mx-auto mb-5 h-1.5 w-10 rounded-full bg-decide-line" />
            <button data-testid="paywall-close" onClick={onClose} className="absolute right-5 top-5 text-decide-mute hover:text-decide-ink" aria-label="Close">
              <X size={22} />
            </button>
            <div className="inline-flex items-center gap-2 rounded-full bg-decide-forestLight px-3 py-1 text-xs font-semibold text-decide-forest">
              <Sparkles size={14} /> DECIDE Pro
            </div>
            <h2 className="mt-4 text-2xl font-semibold tracking-tight text-decide-ink">
              {reason === "limit" ? t("paywall.limitTitle") : t("paywall.unlockTitle")}
            </h2>
            <p className="mt-2 text-decide-slate">{t("paywall.sub")}</p>
            <ul className="mt-5 space-y-3">
              {perks.map((p) => (
                <li key={p} className="flex items-center gap-3 text-decide-ink">
                  <span className="inline-flex h-5 w-5 items-center justify-center rounded-full bg-decide-forest text-white">
                    <Check size={13} strokeWidth={3} />
                  </span>
                  <span className="text-[15px]">{p}</span>
                </li>
              ))}
            </ul>
            <button data-testid="paywall-view-plans" onClick={() => { onClose(); navigate("/pricing"); }} className="btn-accent mt-6 w-full">
              {t("paywall.seePlans")}
            </button>
            <button data-testid="paywall-later" onClick={onClose} className="btn-ghost mt-2 w-full">{t("paywall.notNow")}</button>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}
